import React, { useState } from "react";

import './styles.css';

import LogTable from '../components/LogTable/LogTable';

import DefaultLoader from "../../components/Loader/DefaultLoader";

import useFetchLogs from '../hooks/useFetchLogs';
import useAuthAdmin from "../hooks/useAuthAdmin";
import useSetPageTitle from "../../hooks/useSetPageTitle";

function ActivityAdmin() {
    useAuthAdmin();
    useSetPageTitle('Admin');

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    const { logs } = useFetchLogs(setLoading, setError);

    return(
        <div className="admin-page-container">
            <div className="admin-page-title-container">
                <p className="admin-page-title">Histórico de atividades</p>
                { loading && !error ? <DefaultLoader /> : false }
                { !loading && error ? <p className="admin-page-error-fetching">Ocorreu um erro, por favor recarregue a página</p> : false }
            </div>
            <LogTable logs={logs} />
        </div>
    )
}

export default ActivityAdmin;